/*LIBRARY*/
import { connect, useDispatch } from "react-redux";
import { useEffect } from "react";

/*COMPONENT*/
import CheckBoxNew from "../common_input/CheckBoxNew";
import DROPDOWN_NEW from "../reuseable/Dropdown/DROPDOWN_NEW";

import SET_AT from "./SET_AT"; //Array Templates for selection & checklist
import SET_TL from "./SET_TL"; //Template Literal
import SET_SR from "./SET_SR"; //Simple Refering
import SET_TF from "./SET_TF"; //Table Formula
import SET_CC from "./SET_CC"; //Counting Custom
import SET_2DR from "./SET_2DR"; //2D Reference
import SET_CS from "./SET_CS"; //Conditional Statement
import SET_MO from "./SET_MO"; //Math Operator

import SET_CP from "./SET_CP"; //Counting POI
import SET_CD from "./SET_CD"; //Calculate Dimension
import SET_RANGE from "./SET_RANGE"; //Range number slider
import SET_RAM from "./SET_RAM"; //RAM KAI

/*REDUX*/
import {
  editField,
  editFieldForm,
  push_field_form_reorder,
  pushField,
  pushFieldForm,
} from "../../App/actions/layerActions";
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/
import generate_uuid from "../../App/validation/generate_uuid";

/*DATA*/
import dict from "../../Data/dict.json";
import { data_types } from "../../App/validation/data_types";
import { snackbar } from "../../App/actions/snackbarActions";

/*CONST*/

const EDIT_FIELD = ({
  //variable
  auth,
  layer,
  properties,
  field,
  parent_uuid = "",
  from,
  mode_middle,
  to_uuid,

  //function
  editField,
  pushField,
  set_value_properties,
  toggleEditField,
  togglePushField,
  push_field_form_reorder,
  pushFieldForm,
  editFieldForm,
}) => {
  //local storage
  const language = localStorage?.language || auth?.language;

  //state & ref

  //hooks
  const dispatch = useDispatch();

  //global props
  const domain = window.location.host;

  const { field_editable, is_mobile } = properties;

  //variable
  const type_array = data_types(language);

  const isRestrictedDomain = [
    "geo.mapid.io",
    "geo-alpha.mapid.io",
    "geo-beta.mapid.io",
  ].includes(domain);

  //functions
  useEffect(() => {
    if (field?.key) {
      set_value_properties({
        key: "field_editable",
        value: {
          ...field,
          parent_uuid: parent_uuid || "",
        },
      });
    } else {
      set_value_properties({
        key: "field_editable",
        value: {
          uuid: "",
          key: "",
          name: "",
          description: "",
          unit: "",
          type: "text",
          array_templates: [],
          isHighlight: false,
          isRequired: true,
          isAllowOtherAnswer: true,
          isHide: false,
          defaultValue: "",
          min: 0,
          max: 10,
          step: 1,
          term: [],
          digit_term: [],
          poi_rad: 100,
          reference_list: [],
          reference_key: "",
          formula: [],
          reference_list_2d: {},
          decimal_digits: "",
          conditional_statement_list: [],
          custom_counting_id: "",
          value: "",
          array_value_filter: [],
          is_use_parent_array_template: false,
          parent_uuid: parent_uuid || "",
        },
      });
    }
  }, [field, parent_uuid, set_value_properties]);

  const clearFieldState = () => {
    set_value_properties({
      key: "field_editable",
      value: {
        uuid: "",
        key: "",
        name: "",
        description: "",
        unit: "",
        type: "text",
        array_templates: [],
        isHighlight: false,
        isRequired: true,
        isAllowOtherAnswer: true,
        isHide: false,
        defaultValue: "",
        min: 0,
        max: 10,
        step: 1,
        term: [],
        digit_term: [],
        poi_rad: 100,
        reference_list: [],
        reference_key: "",
        formula: [],
        reference_list_2d: {},
        decimal_digits: "",
        conditional_statement_list: [],
        custom_counting_id: "",
        value: "",
        array_value_filter: [],
        is_use_parent_array_template: false,
        parent_uuid: parent_uuid || "",
      },
    });
  };

  const hasDuplicates = (arr, key) => {
    const seen = new Set();
    return arr.some(item => {
      if (seen.has(item[key])) return true;
      seen.add(item[key]);
      return false;
    });
  };

  const on_submit = (e) => {
    const geo_layer = layer?.geo_layer_wo_geojson?.geo_layer;

    const { layer_id } = layer || {};
    const geo_layer_id = layer_id || geo_layer?._id;

    if (hasDuplicates(field_editable?.array_templates, "name")) {
      dispatch(snackbar({
        is_open: true,
        status: "warning",
        message: dict["The option values must not be the same"][language],
      }))
      return;
    }

    let body = {
      geo_layer_id,
      field: { ...field_editable, parent_uuid },
    };

    if (field_editable?.key) {
      // EDIT MODE
      if (from === "form") {
        editFieldForm(body);
        toggleEditField(); // Close modal for form edit
      } else {
        // from === "map" or other
        editField(body);
        toggleEditField(); // Close modal for map edit
      }
    } else {
      // ADD MODE
      const new_key = generate_uuid();
      body.field.uuid = new_key;
      body.field.key = new_key;
      if (!body?.field?.name)
        body.field.name = `New ${body?.field?.type}` || "Unnamed Field";

      if (from === "form") {
        if (mode_middle) {
          body.fields = geo_layer.fields;
          body.to_uuid = to_uuid;
          push_field_form_reorder(body);
        } else {
          pushFieldForm(body);
        }
        // ADD mode from form: clear state after dispatching action, don't close modal
        setTimeout(() => {
          clearFieldState();
        }, 100);
      } else {
        // from === "map" or other
        pushField(body);
        // togglePushField(); // Close modal for map add
        setTimeout(() => {
          clearFieldState();
        }, 100);
      }
    }
  };

  const left_content = (
    <section>
      <div className="container background_grey_light outline_grey margin_bottom">
        <p className="text_medium sub_color margin_bottom">
          {dict?.["Column Name"]?.[language]}
        </p>
        <input
          placeholder={dict?.["Column Name"]?.[language] + " ..."}
          className="margin_bottom"
          type="text"
          value={field_editable?.name || ""}
          onChange={(event) => {
            set_value_properties({
              key: "field_editable",
              value: {
                ...field_editable,
                name: event?.target?.value,
              },
            });
          }}
        />
        <p className="text_medium sub_color margin_bottom">
          {dict?.["Description"]?.[language]}
        </p>
        <textarea
          placeholder={dict?.["Description"]?.[language] + " ..."}
          className="margin_bottom"
          rows={3}
          type="text"
          value={field_editable?.description || ""}
          onChange={(event) => {
            set_value_properties({
              key: "field_editable",
              value: {
                ...field_editable,
                description: event?.target?.value,
              },
            });
          }}
        />

        <p className="text_medium sub_color margin_bottom">
          {dict?.["Column type"]?.[language]}
        </p>
        <DROPDOWN_NEW
          height="250px"
          placeholder="Pilih"
          filter_on
          is_enable_empty={false}
          value={field_editable?.type}
          array_value={type_array}
          onChange={(value) => {
            set_value_properties({
              key: "field_editable",
              value: {
                ...field_editable,
                type: value,
              },
            });
          }}
        />
      </div>

      <div className="container background_grey_light outline_grey margin_bottom">
        <p className="text_medium sub_color margin_bottom">
          {dict?.["Additional settings (form & pdf)"]?.[language]}
        </p>
        <CheckBoxNew
          text="isRequired"
          title={dict?.["Required to fill in the form"]?.[language]}
          value={field_editable?.isRequired || false}
          handle={() => {
            if (!field_editable?.isRequired) {
              set_value_properties({
                key: "field_editable",
                value: {
                  ...field_editable,
                  isRequired: !field_editable?.isRequired,
                  isHide: false,
                },
              });
            } else {
              set_value_properties({
                key: "field_editable",
                value: {
                  ...field_editable,
                  isRequired: !field_editable?.isRequired,
                },
              });
            }
          }}
        />

        <CheckBoxNew
          text="isHide"
          title={dict?.["Hide columns in the form"]?.[language]}
          value={field_editable?.isHide || false}
          handle={() => {
            if (!field_editable?.isHide) {
              set_value_properties({
                key: "field_editable",
                value: {
                  ...field_editable,
                  isRequired: false,
                  isHide: true,
                },
              });
            } else {
              set_value_properties({
                key: "field_editable",
                value: {
                  ...field_editable,
                  isHide: !field_editable?.isHide,
                },
              });
            }
          }}
        />

        {!isRestrictedDomain && (
          <CheckBoxNew
            text="isHighlight"
            title={dict?.["Show columns in PDF downloads"]?.[language]}
            value={field_editable?.isHighlight || false}
            handle={() => {
              set_value_properties({
                key: "field_editable",
                value: {
                  ...field_editable,
                  isHighlight: !field_editable?.isHighlight,
                },
              });
            }}
          />
        )}
      </div>
    </section>
  );

  const right_content = (
    <section className="container background_grey_light outline_grey">
      <p className="text_medium sub_color margin_bottom">
        {dict?.["Field Type Description & Settings"]?.[language]}
      </p>
      <div className="container background_white margin_bottom">
        <p className="text_medium sub_color">
          {
            type_array.find((item) => item.value === field_editable?.type)?.[
            language
            ]
          }
        </p>
      </div>
      {(() => {
        switch (field_editable?.type) {
          case "template_literal":
            return <SET_TL />;

          case "counting_custom":
            return <SET_CC />;

          case "simple_referring":
            return <SET_SR />;

          case "2d_referring":
            return <SET_2DR />;

          case "math_operators":
            return <SET_MO />;

          case "conditional_statement":
            return <SET_CS />;

          case "table_formula":
            return <SET_TF />;

          case "counting_poi":
            return <SET_CP />;

          case "calculate_dimension":
            return <SET_CD />;

          case "selection":
            return <SET_AT />;

          case "radio_button":
            return <SET_AT />;

          case "checklist":
            return <SET_AT />;

          case "text":
            return <SET_AT />;

          case "range":
            return <SET_RANGE />;

          case "ram":
            return <SET_RAM />;

          default:
            return <></>;
        }
      })()}
    </section>
  );

  return (
    <div>
      <main className={is_mobile ? "" : "two_container_equal"}>
        {left_content}
        {right_content}
      </main>

      <br />
      <br />
      <button className="button_big background_black" onClick={on_submit}>
        {dict?.["Save"]?.[language]}
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  editField,
  set_value_properties,
  pushField,
  push_field_form_reorder,
  pushFieldForm,
  editFieldForm,
})(EDIT_FIELD);
